module.exports = __webpack_public_path__ + "img/ImageQstep5.4907a51b.png";